import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: () => import('@/views/Home') },
    { path: '/products', component: () => import('@/views/Products') },
    { path: '/about', component: () => import('@/views/About') },
    { path: '/contact', component: () => import('@/views/Contact') }
  ]
})